var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-cf",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-12.4 32h640v480h-640z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(12.4 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00f",
    d: "M-52 32h719.3v119H-52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M-52 391.6h719.3V512H-52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009a00",
    d: "M-52 271.3h719.3v120.3H-52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-52 151h719.3v120.3H-52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M247.7 32.5h119.9V512H247.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "m99.3 137.7-31.5-21.8-31.3 22L47.4 101 16.9 78l38.2-1 12.5-36.3L80.3 77l38.1.7L88.2 101"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCf);
export default __webpack_public_path__ + "static/media/cf.92ff73b026ce144a88f10f418a5e1c6a.svg";
export { ForwardRef as ReactComponent };